import PriorityHighIcon from "@material-ui/icons/PriorityHigh";
import React, { FC } from "react";

import { CircleIconButton } from "@/features/common/components/button/CircleIconButton";
import { useCommonIconStyles } from "@/features/common/styles";

type ReportUserButtonProps = {
  isOnOverlay?: boolean;
};
export const ReportUserButton: FC<ReportUserButtonProps> = (props) => {
  const { isOnOverlay } = props;
  const classes = useCommonIconStyles();

  const onClickButton = async () => {};

  return (
    <CircleIconButton
      aria-label="report"
      isOnOverlay={isOnOverlay}
      loading={false}
      onClick={onClickButton}
      disabled={true}
      active={false}
    >
      <PriorityHighIcon className={classes.smallIcon} />
    </CircleIconButton>
  );
};
